import React, { useState } from "react";
import { useTable, useSortBy } from "react-table";
import xl from "../../assets/images/xl.svg";
import pdf from "../../assets/images/pdf.svg";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import "./table.css";
import SearchBar from "../common/SearchBar/SearchBar";
import Loader from "../Loader/Loader";
import moment from "moment";

const Table = ({
  columns,
  data,
  onEdit,
  isLoading,
  onDelete,
  onToggleStatus,
  setIsSelectRow = () => {},
  name,
  isDownload = true,
  isSearch = true,
  onSearch = () => {},
  totalCount,
  pageIndex,
  pageSize,
  setPageIndex,
  setPageSize,
  isCheckBox=false
}) => {
  const [selectedRows, setSelectedRows] = useState([]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
        manualPagination: true,
        pageCount: Math.ceil(totalCount / pageSize),
      },
      useSortBy
    );

  const totalPages = Math.ceil(totalCount / pageSize);

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };
  const downloadPDF = () => {
    const doc = new jsPDF();

    // Filter out the "Action" column
    const exportableColumns = columns.filter(
      (col) => col.Header !== "Action" && col.accessor
    );

    // Table head
    const tableHead = [exportableColumns.map((col) => col.Header)];

    // Table body
    const tableBody = rows.map((row) => {
      prepareRow(row);
      return exportableColumns.map((col) => {
        const accessor = col.accessor;
        const value = getNestedValue(row.original, accessor);
        // If "createdAt", format it
        if (accessor === "createdAt") {
          return moment(value).format("DD-MM-YYYY");
        }
        return value !== undefined && value !== null ? String(value) : "";
      });
    });

    doc.autoTable({
      head: tableHead,
      body: tableBody,
    });

    doc.save("table.pdf");
  };

  const downloadExcel = () => {
    // Filter out columns like "Action"
    const exportableColumns = columns.filter(
      (col) => col.Header !== "Action" && col.accessor
    );

    // Prepare data rows
    const excelData = rows.map((row) => {
      prepareRow(row);
      const rowData = {};
      exportableColumns.forEach((col) => {
        const accessor = col.accessor;
        const value = getNestedValue(row.original, accessor);

        // Format date if it's createdAt
        if (accessor === "createdAt") {
          rowData[col.Header] = moment(value).format("DD-MM-YYYY");
        } else {
          rowData[col.Header] =
            value !== undefined && value !== null ? String(value) : "";
        }
      });
      return rowData;
    });

    // Create sheet and workbook
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "table.xlsx");
  };

  const handleSelectAllRows = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
      setIsSelectRow([]);
    } else {
      const allIds = data.map((row) => row._id);
      setSelectedRows(allIds);
      setIsSelectRow(allIds);
    }
  };

  const handleSelectRow = (rowId) => {
    const updatedSelection = selectedRows.includes(rowId)
      ? selectedRows.filter((id) => id !== rowId)
      : [...selectedRows, rowId];
    setSelectedRows(updatedSelection);
    setIsSelectRow(updatedSelection);
  };

  return (
    <>
      <div className="table_outer">
        <div className="d-flex justify-content-between align-items-center mb-3 p-3 pb-0">
          {name && <h4 className="name mb-0">{name}</h4>}

          {isDownload && (
            <div className="tableTop">
              <span>Download : </span>
              <span onClick={downloadPDF}>
                <img src={pdf} alt="Download PDF" />
              </span>
              <span onClick={downloadExcel}>
                <img src={xl} alt="Download Excel" />
              </span>
            </div>
          )}

          {isSearch && (
            <SearchBar className="rounded" handelSearchBar={onSearch} />
          )}
        </div>

        <table className="table_default w-100" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup , index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
               {isCheckBox ?<th>
                  <input
                    type="checkbox"
                    checked={selectedRows.length === data.length}
                    onChange={handleSelectAllRows}
                  />
                </th> :<>
                <th>  S.NO </th>
                </>}
                
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={column.id}
                  >
                    <span className="table_header_wrap">
                      {column.render("Header")}
                      <span className="icon">
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <i className="fas fa-sort-down"></i>
                          ) : (
                            <i className="fas fa-sort-up"></i>
                          )
                        ) : (
                          <>
                            <i className="fas fa-sort-up"></i>
                            <i className="fas fa-sort-down"></i>
                          </>
                        )}
                      </span>
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {isLoading ? (
            <tbody>
              <tr>
                <td
                  colSpan="100%"
                  className="text-center align-middle"
                  style={{ height: "100px" }}
                >
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : data.length > 0 ? (
            <tbody {...getTableBodyProps()}>
              {rows.map((row , index) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={row.id}>
                    {isCheckBox ? <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(row.original._id)}
                        onChange={() => handleSelectRow(row.original._id)}
                      />
                    </td>:<>
                    
                  <td>{index + 1}</td>  
                    </>}
                    
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()} key={cell.column.id}>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td
                  colSpan="100%"
                  className="text-center align-middle"
                  style={{ height: "100px" }}
                >
                  No Data Found
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>

      <div className="tableFooter d-flex justify-content-between align-items-center px-4 py-4">
        <div className="tableFooterLeft">
          <span>Show</span>
          <select
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPageIndex(0); // reset to first page on size change
            }}
          >
            {[5, 10, 20, 30].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
          Showing results <strong>{pageIndex + 1}</strong> of{" "}
          <strong>{totalPages}</strong>
        </div>
        <div className="pagination">
          <button
            onClick={() => setPageIndex(pageIndex - 1)}
            disabled={pageIndex === 0}
          >
            {"<"}
          </button>
          <button
            onClick={() => setPageIndex(pageIndex + 1)}
            disabled={pageIndex + 1 >= totalPages}
          >
            {">"}
          </button>
        </div>
      </div>
    </>
  );
};

export default Table;
